import { useState } from "react";

import { useTranslation } from "@/core/i18n";
import { ModalSelectorList } from "organisms/selection-modals/modal-selector-list/ModalSelectorList";

interface TreatmentSelectorModalProps {
  // todo: change to Treatment type
  treatments: {
    id: string;
    name: string;
    quantity?: number;
  }[];
  primaryOnClick: (id: string, quantity: number) => void;
  primaryLabel: string;
  onClose: () => void;
}

export const TreatmentSelectorModal = ({
  treatments,
  primaryOnClick,
  primaryLabel,
  onClose,
}: TreatmentSelectorModalProps) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");

  return (
    <ModalSelectorList
      size="fullscreen"
      onClose={onClose}
      open={true}
      title={t("treatmentsTreatmentSelectorModal.title")}
      type="products"
      firstButtonLabel={primaryLabel}
      onFirstButtonClick={() => primaryOnClick(selected, 1)}
      firstButtonDisabled={!selected}
      items={treatments.map((treatment) => ({
        id: treatment.id,
        title: treatment.name,
        subtitle: treatment.quantity
          ? t("treatmentsTreatmentSelectorModal.unitsAvailable", { quantity: treatment.quantity })
          : undefined,
      }))}
      checkedItems={selected}
      onSelect={(itemId) => setSelected(itemId)}
    />
  );
};
